import { Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import Center from "./pages/Center";
// import i18n from "./components/language/i18n";


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Center />} />

        </Route>
      </Routes>
    </div>
  );
}

export default App;
